import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@ridereserv/shared/utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

/**
 * Input component for forms.
 * Uses semantic color tokens from the design system.
 */
const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 pointer-fine:h-9 w-full rounded-sm border bg-surface px-3 py-2 text-sm text-foreground transition-colors",
          "placeholder:text-neutral-400",
          "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-1",
          "disabled:cursor-not-allowed disabled:opacity-50",
          error
            ? "border-destructive-500 focus:ring-destructive-500"
            : "border-neutral-300 hover:border-neutral-400",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";

export { Input };
